const badgeTypes = {
    WELCOME_TO_IQOS_CLUB: 'WELCOME',
    IQOS_CLUB_FIRST_STEPS: 'GUIDED',
    CONNECTIVITY_CHAMPION: 'CONNECTIVITY_MASTER',
    IQOS_EXPERT: 'EXPERT',
    QUEST_CHAMPION: 'QUEST_CHAMPION',
    SWITCH_MASTER: 'SWITCH',
};

export default badgeTypes;
